module.exports = __webpack_public_path__ + "static/media/zoom-in.82d996c8.svg";